'use strict';

var NetSpillRateDirective = function NetSpillRateDirective() {
  return {
    restrict: 'E',
    template: require('../templates/net-spill-rate.html'),
    controller: 'NetSpillRateController'
  };
};
NetSpillRateDirective.$inject = [];
module.exports = NetSpillRateDirective;